import { createSelector } from 'reselect'

export const selectTranscribeModels = createSelector(
  [ state => state.transcribe.transcribeModels ],
  transcribeModels => transcribeModels as Array<string>
)
